import React from 'react';
import { Card, CardTitle, CardText } from 'reactstrap';

const TournamentCards = (props) => {

  var articleCardStyle = {
    maxWidth:320,
    minWidth:300,
    marginBottom: 10
  };

  var titleStyle = {
    fontFamily: "Audiowide, cursive",
    color: "cadetblue"
  }

  return (
    <React.Fragment>
        <Card body style={articleCardStyle}>
          <CardTitle style={titleStyle}>Sign Up Instructions</CardTitle>
          <CardText><a href="https://docs.google.com/document/d/1J5rkYO5dTIKPSA9F6thOPmtohXWAzhenTa6W0-Qa9pc/edit?usp=sharing">Sign Up & Check In Process</a></CardText>
        </Card>

        <Card body style={articleCardStyle}>
          <CardTitle style={titleStyle}>Prize Structure</CardTitle>
          <CardText>
            <a href="https://docsend.com/view/5mw2j9u">Player Run Tournament Program</a>
          </CardText>
        </Card>

        <Card body style={articleCardStyle}>
          <CardTitle style={titleStyle}>Eth Wallets</CardTitle>
          <CardText>For holding all your winnings!<br />
            <a href="https://myetherwallet.github.io/knowledge-base/getting-started/creating-a-new-wallet-on-myetherwallet.html">MyEtherWallet</a><br/>
            <a href="https://metamask.io/">MetaMask</a>
          </CardText>
        </Card>



    </React.Fragment>
  );
};

export default TournamentCards;



// WEBPACK FOOTER //
// ./src/Tournaments/TournamentCards.js